import * as Sentry from '@sentry/nextjs';

/**
 * Minimal user fields used to tag the active Sentry scope.
 * `username` maps to Sentry's username field (e.g. display name or role).
 */
export type ApplySentryUserInput = Readonly<{
  id: string;
  email?: string | null;
  name?: string | null;
  username?: string | null;
}>;

/**
 * Sets or clears the current Sentry user on {@link Sentry.getCurrentScope}.
 * No-ops when `NEXT_PUBLIC_SENTRY_ENABLED` is not exactly `'true'`.
 * @param user User to attach, or `null`/`undefined` to clear tagging
 */
export function applySentryUser(user: ApplySentryUserInput | null | undefined): void {
  if (process.env.NEXT_PUBLIC_SENTRY_ENABLED !== 'true') {
    return;
  }

  if (!user) {
    Sentry.getCurrentScope().setUser(null);
    return;
  }

  const displayUsername = user.username ?? user.name;
  const payload: Sentry.User = { id: user.id };

  if (user.email != null && user.email !== '') {
    payload.email = user.email;
  }
  if (displayUsername != null && displayUsername !== '') {
    payload.username = displayUsername;
  }

  Sentry.getCurrentScope().setUser(payload);
}
